import { render, staticRenderFns } from "./contactlists.vue?vue&type=template&id=d96e4f06&scoped=true&"
import script from "./contactlists.vue?vue&type=script&lang=js&"
export * from "./contactlists.vue?vue&type=script&lang=js&"
import style0 from "./contactlists.vue?vue&type=style&index=0&lang=css&"
import style1 from "./contactlists.vue?vue&type=style&index=1&id=d96e4f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e4f06",
  null
  
)

export default component.exports